import { input } from '@angular/core';
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { padEnd } from 'lodash';

const MaterialPreset = definePreset(Material, {
    components: {
        multiselect: {
            padding: {
                y: '5px',
            },
            focus: {
                ring: {
                    color: '#4767f9',
                }
            },
            option: {
                selected: {
                    color: '#4767f9',
                    background: '#E0E4F9',
                    focus: {
                        background: '#DFDCF9',
                        color: '#4767f9'
                    }
                }
            }
        },
        checkbox: {
            checked: {
                background: '#4767f9',
            }
        }, 
        chip: {
            padding: {
                y: '5px'
            },            
            border: {
                radius: '5px'
            },
            colorScheme: {
                light: {
                    background: '#f7f7f7',                    
                },                
            },            
        },
        inputtext: {
            padding: {
                y: '5px',
            }
        },
        datatable: {
            colorScheme: {
                light: {
                    row: {
                        striped: {                    
                            background: '#f7f7f7'                    
                        }
                    },
                }
            },
        },
        select: {
            padding: {
                x: '5px',
                y: '6.5px'
            }
        }
    }
});
export default MaterialPreset;